export default __webpack_public_path__ + "4395bb4d83b09192758139818cc41819.png";